import { RpcError } from '@lyra/core/api/error'
import Notice from '@lyra/core/components/Notice'
import React from 'react'

type Props = {
  error: Error
}

function replaceLongNumbers(input: string): string {
  // Regex to find numbers with a decimal point and many digits
  const numberRegex = /\b\d+\.\d{3,}\b/g

  // Replace each found number with its rounded version (2 decimal places)
  return input.replace(numberRegex, (match) => {
    const roundedNumber = parseFloat(match).toFixed(2)
    return roundedNumber
  })
}

const formatRpcError = (error: RpcError): string => {
  switch (error.code) {
    case 11000:
      // insufficient funds
      return 'Insufficient balance. Try reducing order amount.'
    case 10004:
      // multiple currencies not supported on PM
      return `Cannot trade ${error.data?.base_asset_currency} markets on a ${error.data?.subaccount_currency} Portfolio Margin account`
    case 11013:
      // limit price is zero
      return 'Enter limit price'
    default:
      return error.data
        ? `${error.message}: ${replaceLongNumbers(
            typeof error.data === 'string' ? error.data : JSON.stringify(error.data)
          )}`
        : error.message
  }
}

export default function TradeErrorNotice({ error }: Props) {
  return (
    <Notice
      message={error instanceof RpcError ? formatRpcError(error) : error.message}
      status="error"
      width="100%"
    />
  )
}
